/**
 * Volume formatting shared by the API (PDF) and the Admin frontend so the two
 * never drift.
 */

/**
 * Format a volume value without a forced ".00" — trailing zero decimals are
 * dropped (e.g. 5000 → "5,000", 5000.5 → "5,000.5"). Keeps the en-US
 * thousands separator. Returns 'N/A' for null/undefined.
 */
export const formatVolume = (value: number | null | undefined): string =>
  value === null || value === undefined
    ? 'N/A'
    : Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
